import { SupportAgent } from "@mui/icons-material";
import { Box, Link, Typography } from "@mui/material";
import { useState } from "react";
import { IconButtonAnimate } from "src/components/animate";
import MenuPopover from "src/components/MenuPopover";
import useTenantConfigData from "src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData";
import useAuth from "src/careflow/ph-core/authentication/hook/useAuth";

const LinksList = () => {
  const { componentsData } = useTenantConfigData();
  const { getSelectedOrg } = useAuth();
  const selectedOrgName = getSelectedOrg()?.name ?? '';

  const allLinks = componentsData?.header?.helpLinks ?? [];

  const hasOrgMatch = allLinks.some(
    (item) => item.orgNames && item.orgNames.length > 0 && item.orgNames.includes(selectedOrgName)
  );

  const visibleLinks = allLinks.filter((item) => {
    if (item.orgNames === undefined || item.orgNames === null) return true; // always show
    if (item.orgNames.length === 0) return !hasOrgMatch; // fallback: show only when no org match
    return item.orgNames.includes(selectedOrgName); // org-specific
  });

  const [open, setOpen] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      {visibleLinks.length > 0 && (
        <IconButtonAnimate 
          color={open ? 'primary' : 'default'}
          onClick={handleOpen}
          sx={{ width: 40, height: 40 }}
        >
          <SupportAgent />
        </IconButtonAnimate>
      )}

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: 260 }}
      >
        <Box sx={{ alignItems: 'center', p: 2 }}>
          {visibleLinks.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                rowGap: 0.4, 
                mb: 1
              }}
            >
              {item.pieces.map((piece, index2) => {
                return piece.url ? (
                  <Link
                    key={index2}
                    {...piece?.properties}
                    href={piece.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {piece.text}
                  </Link>
                ) : (
                  <Typography 
                    key={index2}
                    component="p"
                    {...piece?.properties}
                  >
                    {piece.text}
                  </Typography>
                );
              })}
            </Box>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
};

export default LinksList;